"use client";

import { c as _c } from "react/compiler-runtime";
import { Breadcrumbs } from "@/components/common/breadcrumbs";
import { type SellerUnitsAndProjectsOne } from "@/types/sup";
import { buildSupOrProjectBreadcrumbItems } from "@/utils/breadcrumbs/sup";
import { type BreadcrumbItem } from "@/utils/breadcrumb-utils";
import { useRouter } from "next/navigation";
import { useMemo } from "react";
interface BreadcrumbsWrapperProps {
  city?: string;
  slug?: string;
  className?: string;
  supOne?: SellerUnitsAndProjectsOne;
  projectDetails?: {
    projectName: string;
  };
}

// for unit and project pages only, not for search page
export function BreadcrumbsWrapper(t0) {
  const $ = _c(13);
  const {
    city,
    slug,
    className,
    supOne,
    projectDetails
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== city || $[1] !== projectDetails || $[2] !== slug || $[3] !== supOne) {
    t1 = buildSupOrProjectBreadcrumbItems({
      city,
      slug,
      supOne,
      projectDetails
    });
    $[0] = city;
    $[1] = projectDetails;
    $[2] = slug;
    $[3] = supOne;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const breadcrumbItems = t1;
  let t2;
  if ($[5] !== router) {
    t2 = item => {
      if (item.href) {
        if (item.variant === "city") {
          window.location.href = item.href;
        } else {
          router.push(item.href);
        }
      }
    };
    $[5] = router;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleBreadcrumbClick = t2;
  let t3;
  if ($[7] !== breadcrumbItems || $[8] !== handleBreadcrumbClick) {
    t3 = <Breadcrumbs items={breadcrumbItems} onBreadcrumbClick={handleBreadcrumbClick} />;
    $[7] = breadcrumbItems;
    $[8] = handleBreadcrumbClick;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== className || $[11] !== t3) {
    t4 = <div className={className}>{t3}</div>;
    $[10] = className;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}